import { addCategoryRequest, addCategoryRequestSuccess, addCategoryRequestError } from "../../slices/Category/AddCategorySlice";
import axiosInstance from "../../../api/axiosInstance";
import { endpoints } from "../../../services/endpoints";

export const AddCategoryAPI = (data) => {

    const url = `${endpoints.addCategory}`
    return async (dispatch) => {
        try {
            dispatch(addCategoryRequest());
            const response = await axiosInstance({
                method: "POST",
                url: url,
                data: data,
                // headers: { "Content-Type": "application/json" },
            })
            return dispatch(addCategoryRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addCategoryRequestError(_error));
        }
    };
};
